








import { Component, Mixins, Prop } from "vue-property-decorator";

@Component({
  components: {
  }
})
export default class PageBorderLine extends Mixins() {
  @Prop()
  y: number;

  get rootStyleProperties(): any {
    return {
      top: (this.y - 2) + "px",
      height: "4px",
    };
  }

  get path(): any {
    return "M 0 2 H 10000";
  }

  get lineStyleProperties() {
    return {
      stroke: "black",
      strokeWidth: 1,
      pointerEvents: "none",
      strokeDasharray: "3",
    };
  }
}
